module.exports = __webpack_public_path__ + "static/img/case_detail_07_3.74f5f57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_07_3.png
// module id = n9Xr
// module chunks = 34